import MessageEditorPreview from '@common-components/message-editor/message-editor-preview'
import { Button } from '@/components/ui/button'
import { setActiveTab } from '@common-reducers/CampaignReducer'
import { campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks"
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { Pencil } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

type Props = {
    campaignId?: string;
}


export default function CampaignSummaryMessageTemplateDialog({ campaignId }: Props) {
    const dispatch = useAppDispatch()
    const { t } = useTranslation(namespace);
    let campaign
    const _campaign = useAppSelector((state) => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, { _id: campaignId }))
    const newCampaign = useAppSelector((state) => state.CampaignReducer.newCampaign)

    if (campaignId) campaign = _campaign
    else campaign = newCampaign

    if (!campaign) return null;

    return (
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 w-full">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-sky-600 dark:text-sky-400 flex items-center gap-2">
                    {t('campaignSummary.message')}:
                </h2>
                {!campaignId && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => dispatch(setActiveTab('messageAndFiles'))}
                        className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors h-8 w-8"
                    >
                        <Pencil className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                    </Button>
                )}
            </div>
            <div className={cn(
                "flex flex-row items-start gap-4",
                "w-full"
            )}>
                {(campaign?.template?.message && campaign?.template?.message !== '' && !campaign.template?.isPoll) && (
                    <div className="flex-1">
                        <MessageEditorPreview
                            template={campaign?.template as Parameters<typeof MessageEditorPreview>[0]['template']}
                            editorContext='scheduleCampaign'
                            isPreview={true}
                        />
                    </div>
                )}
                {!((campaign?.template?.message && campaign?.template?.message !== '') || campaign.template?.isPoll) && (
                    <p className={cn(
                        "text-slate-700 dark:text-slate-300",
                        "font-medium"
                    )}>
                        {t('campaignSummary.noMessageSelected')}
                    </p>
                )}
                {campaign.template?.isPoll && (
                    <p className={cn(
                        "text-sm font-semibold text-slate-700 dark:text-slate-300",
                        "max-w-full"
                    )}>
                        Poll: {campaign.template.poll?.question}<br />
                        {campaign.template.poll?.options
                            ?.filter((option: { text: string }) => option.text !== '')
                            .map((option: { text: string }, index: number) => (
                                <span key={index}>
                                    {`${index}) ${option.text}`} <br />
                                </span>
                            ))}
                    </p>
                )}
            </div>
        </div>
    )
}